import { Injectable } from '@angular/core';
import { EnvService } from '../env.service';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  httpOptions = {};
  apiURL = '';
  constructor(private http: HttpClient, envService: EnvService) {
    this.apiURL = envService.API_URL;
  }

  getPromotion(id: string, options: any) {
    if (options) {
      let scopes = '';
      const opts = Object.assign({}, options);
      if (opts.scope && opts.scope.length) {
          scopes = '?';
          const optScopes = opts.scope;
          optScopes.forEach((queryParameter) => {
              scopes += queryParameter + '=1&';
          });
      }
      const apiUrl = this.apiURL + 'promotions/' + id.toString() + scopes;
      return this.http.get(apiUrl);
    }
  }

   //For triggering Mixpanel event for Join now click
   joinPromotion(id: string) {
     return this.http.get(this.apiURL + 'promotions/joinnow/'+id);
   }
}
